import { useRef, useState } from 'react';
import { FormHelperText, IconButton, InputAdornment, TextField } from '@mui/material';
import { CalendarMonthRounded } from '@mui/icons-material';

const DateTextInput = ({
  fieldName,
  label,
  register,
  errors,
  variant,
  required,
  value,
  sx,
  error,
  helperText,
  InputProps,
}) => {
  const [focused, setFocused] = useState(false);
  const [hasValue, setHasValue] = useState(!!value);
  const inputRef = useRef(null);

  const handleCalendarClick = () => {
    if (inputRef.current) {
      inputRef.current.showPicker?.();
      inputRef.current.focus();
    }
  };

  const { onBlur: rhfOnBlur, onChange: rhfOnChange, ...restRegister } = register(fieldName, {
    required: {
      value: required,
      message: 'Debe ingresar ' + label,
    },
  });

  return (
    <>
      <TextField
        sx={{
          ...sx,
          '& input[type="date"]': {
            '&::-webkit-datetime-edit': {
              opacity: focused || hasValue ? 1 : 0,
            },
            '&::-webkit-calendar-picker-indicator': {
              display: 'none',
            },
          },
        }}
        inputRef={inputRef}
        InputProps={{
          ...InputProps,
          endAdornment: (
            <InputAdornment position='end'>
              <IconButton aria-label='abrir calendario' onClick={handleCalendarClick} edge='end'>
                <CalendarMonthRounded />
              </IconButton>
            </InputAdornment>
          ),
        }}
        variant={variant}
        fullWidth
        name={fieldName}
        label={label}
        type='date'
        defaultValue={value}
        id={fieldName}
        InputLabelProps={{
          shrink: focused || hasValue || undefined,
        }}
        onFocus={() => setFocused(true)}
        onBlur={(e) => {
          setFocused(false);
          rhfOnBlur(e);
        }}
        onChange={(e) => {
          setHasValue(!!e.target.value);
          rhfOnChange(e);
        }}
        {...restRegister}
      />
      {error && <FormHelperText>{helperText}</FormHelperText>}
      {!error && errors[fieldName] && <p style={{ color: 'red' }}>{errors[fieldName].message}</p>}
    </>
  );
};
DateTextInput.defaultProps = {
  required: true,
  variant: 'standard',
};
export default DateTextInput;
